import React, { Component } from 'react'
import { Headers, FormHelpers } from '../../helpers'
import axios from 'axios'
import Dropzone from 'react-dropzone'
import FormData from 'form-data'
import * as actions from '../../actions'
import { apiUrl } from '../../config/settings'
import './linkformstyle.css'

class LinkForm extends Component {
  constructor (props) {
    super(props)

    this.state = {
      link: {
        type: 'Link',
        description: '',
        url: ''
      },
      dropzoneActive: false,
      progress: 0,
      displayProgress: false
    }

    this.handleUserChange = this.handleUserChange.bind(this)
    this.handleUpload = this.handleUpload.bind(this)
    this.saveLink = this.saveLink.bind(this)
  }

  handleUpload (accepted, rejected) {
    if (accepted.length > 0) {
      const file = accepted[0]
      if (file.size > 10 * 1024 * 1024) {
        this.props.dispatch(actions.displayAlert('Max file size: 10mb'))
        return
      }

      this.uploadFile(file)
    }
  }

  uploadFile (file) {
    let data = new FormData()
    data.append('file', file)
    data.append('team', this.props.id)
    const options = {
      headers: Headers.getWithAuth(),
      onUploadProgress: (progressEvent) => {
        let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        this.setState({ progress: percentCompleted, displayProgress: true })
      }
    }

    axios
      .post(`${apiUrl}/files/upload`, data, options)
      .then(res => {
        if (res.data.success) {
          const { url } = res.data
          let linkClone = { ...this.state.link }
          linkClone.url = url
          this.setState({
            link: linkClone,
            dropzoneActive: false,
            progress: 0,
            displayProgress: false
          })
          return
        }

        this.props.dispatch(actions.displayAlert('Unsuccessfull upload.'))
      })
  }

  handleUserChange (event) {
    FormHelpers.handleFormChange.bind(this)(event, 'link')
  }

  saveLink () {
    if (this.state.link.url === '') {
      return
    }
    let linksClone = [...this.props.links]
    linksClone.push(this.state.link)
    const ev = {
      target: { name: 'links', value: linksClone }
    }

    this.props.onSubmit(ev)
    this.props.hideForm()
  }

  render () {
    const { type, description, url } = this.state.link

    return (
      <div>
        <div className='line-myteam' style={{ marginBottom: '10px' }} />
        <Dropzone
          disableClick
          className='link-droparea'
          onDrop={this.handleUpload}
          onDragEnter={() => this.setState({ dropzoneActive: true })}
          onDragLeave={() => this.setState({ dropzoneActive: false })}>
          {this.state.dropzoneActive &&
            <div className='link-dropzone'>{this.state.displayProgress ? `${this.state.progress}%` : 'Drop file...'}</div>}

          <div className='chat-message link-form'>
            <form name='chat-message'>
              <select
                name='type'
                className='chat-message'
                value={type}
                onChange={this.handleUserChange}>
                <option>Link</option>
                <option>Resource</option>
              </select>
            </form>
          </div>
          <div className='chat-message link-form'>
            <form name='chat-message'>
              <textarea
                name='description'
                placeholder='Description'
                className='chat-message'
                value={description}
                onChange={this.handleUserChange} />
            </form>
          </div>
          <div className='chat-message link-form'>
            <form name='chat-message'>
              <textarea
                name='url'
                placeholder='Paste URL or drop file'
                className='chat-message'
                value={url}
                onChange={this.handleUserChange} />
            </form>
          </div>
        </Dropzone>
        <button className='button button-sm' onClick={this.saveLink}>ADD</button>
        <button className='button button-sm  link-form-bttn' onClick={this.props.hideForm}>CANCEL</button>
        <div className='line-myteam' style={{ marginTop: '10px' }} />
        <div className='info-text'>* Resources are visible to teammates only</div>
        <div className='info-text'>* Links are public</div>
      </div>
    )
  }
}

export default LinkForm



// WEBPACK FOOTER //
// ./src/screens/team/LinkForm.js